import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import { SocialBanner } from './SocialBanner';

export function Footer({ siteName = 'Patrick Noah' }) {
  return (
    <Box
      component="footer"
      sx={{
        mt: 'auto',
        py: 3,
        bgcolor: 'primary.dark',
        color: 'primary.contrastText',
        borderTop: '1px solid rgba(255,255,255,0.06)',
      }}
    >
      <Container maxWidth="lg">
        <SocialBanner />
        <Typography variant="body2" align="center" sx={{ color: 'rgba(255,255,255,0.8)' }}>
          © {new Date().getFullYear()} {siteName} – Afro Cuban Music
        </Typography>
      </Container>
    </Box>
  );
}

export default Footer;
